import { z } from "zod";
const environmentSchema = z.object({
  uid: z.string().brand(),
  name: z.string().optional().default("Default Environment"),
  color: z.string().optional().default("#FFFFFF"),
  value: z.string().default(""),
  isDefault: z.boolean().optional()
});
export {
  environmentSchema
};
//# sourceMappingURL=environment.js.map
